module.exports = "<span class=\"cartItemMessage--errorQuanity\" ng-bind-html=\"$ctrl.inlineMessage.message.errorMessage\"></span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/cart/cartitemmessages/error-quantity.html
// module id = 172
// module chunks = 0 1